module.exports = __webpack_public_path__ + "img/PA.5dd4c67b.svg";